"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NzForm = NzForm;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _formik = require("formik");

var _Button = require("../button/Button");

var _colors = require("../../theme/colors");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    fieldContainer: {
      marginBottom: '1.5rem'
    },
    inputRow: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: '40.625rem',
      margin: '0 auto',
      fontFamily: 'Novozymes, Arial'
    }, theme.breakpoints.down('xs'), {
      display: 'block',
      maxWidth: '25rem',
      margin: '0 1rem'
    }),
    label: _defineProperty({
      fontSize: '1.125rem',
      lineHeight: '1.3125rem',
      letterSpacing: '0.071875rem'
    }, theme.breakpoints.down('xs'), {
      marginBottom: '0.25rem'
    }),
    input: {
      width: 'calc(100% - 2rem)',
      maxWidth: '23rem',
      height: '2.375rem',
      border: "1px solid ".concat(_colors.colors.black),
      borderRadius: '3.75rem',
      padding: '0 1.5rem',
      fontSize: '0.875rem',
      '&:focus': {
        outline: 'none',
        border: '1px solid #000'
      }
    },
    errorInput: {
      border: "1px solid ".concat(_colors.colors.errorRed)
    },
    submitButtonContainer: _defineProperty({
      textAlign: 'right',
      maxWidth: '40.625rem',
      margin: '2.5rem auto 0 auto'
    }, theme.breakpoints.down('xs'), {
      maxWidth: '25rem',
      textAlign: 'center'
    }),
    errorMessage: {
      color: _colors.colors.errorRed,
      position: 'absolute',
      left: '-1.5rem',
      width: '100%'
    }
  };
});

function NzForm(_ref) {
  var submitForm = _ref.submitForm,
      initialValues = _ref.initialValues,
      fields = _ref.fields,
      formValidation = _ref.formValidation,
      props = _objectWithoutProperties(_ref, ["submitForm", "initialValues", "fields", "formValidation"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: initialValues,
    enableReinitialize: true,
    validate: typeof formValidation === 'function' ? function (values) {
      return formValidation(values);
    } : undefined,
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      submitForm(values);
      setSubmitting(false);
      setEditMode(false);
    }
  }, function (_ref3) {
    var handleSubmit = _ref3.handleSubmit,
        isSubmitting = _ref3.isSubmitting,
        errors = _ref3.errors;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formik.Form, null, fields.map(function (f, idx) {
      var isError = errors.hasOwnProperty(f.name);
      return /*#__PURE__*/_react["default"].createElement(_core.Box, {
        key: f.name,
        className: classes.fieldContainer
      }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
        className: classes.inputRow,
        key: idx
      }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
        className: classes.label
      }, f.label), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        disabled: !editMode || isSubmitting,
        type: f.type || 'text',
        name: f.name,
        className: "".concat(classes.input, " ").concat(isError ? classes.errorInput : '')
      })), /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
        className: classes.errorMessage,
        name: f.name,
        component: "div"
      }));
    })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
      className: classes.submitButtonContainer
    }, editMode ? /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      disabled: isSubmitting,
      onClick: function onClick() {
        return handleSubmit();
      }
    }, "Save") : /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      onClick: function onClick() {
        return setEditMode(true);
      }
    }, "Edit")));
  }));
}